import { ELOACaseListResponse, ELOASingleListResponse } from "@ntprsrf-frontend/service/src/responses/internet/eloa.response";
import { defineStore } from "pinia";
import { Subscription } from "rxjs";

export const useELOAStore = defineStore('eloa', {
    state: () => <{
        transactionId: string | null,
        paymentTransactionIdList: string[],
        lockedCases: ELOACaseListResponse | null,
        confirmedCases: ELOASingleListResponse | null,
        availablePaymentMethods: string[],
        initialLoad: boolean,
        fetchId?: string | null,
        fetchingSubscription?: Subscription | null,
      }>({
      transactionId: null,
      paymentTransactionIdList: [],
      lockedCases: null,
      confirmedCases: null,
      availablePaymentMethods: [],
      initialLoad: true,
    }),
    getters: {
      getLockedCases: st => st.lockedCases,
      getConfirmedCases: st => st.confirmedCases,
      getAvailablePaymentMethods: st => st.availablePaymentMethods, 
      getFetchId: st => st.fetchId,
  },
    actions: {
      setTransactionId(transactionId: string) {
        this.transactionId = transactionId;
      },
      setPaymentTransactionIdList(paymentTransactionIdList: string[]) {
        this.paymentTransactionIdList = paymentTransactionIdList;
      },
      setLockedCases(lockedCases: ELOACaseListResponse){
        this.lockedCases = lockedCases;
      },
      setConfirmedCases(confirmedCases: ELOASingleListResponse){
        this.confirmedCases = confirmedCases;
      },
      setAvailablePaymentMethods(availablePaymentMethods: string[]) {
        this.availablePaymentMethods = availablePaymentMethods;
      },
      setInitialLoad(initialLoad: boolean) {
        this.initialLoad = initialLoad;
      },
      setFetchId(fetchId: string | null) {
        this.fetchId = fetchId;
      },
      setFetchingSubscription(fetchingSubscription: Subscription | null) {
        this.fetchingSubscription = fetchingSubscription;
      },
      unsubscribeFetchingSubscription() {
        if (this.fetchingSubscription) {
          this.fetchingSubscription.unsubscribe();
          this.fetchingSubscription = null;
        }
      }
    },
    persist: true,
  });